<div class="multi-fields">
    <div box>
        <div item *ngFor="let g of group;let i = index">{{ g }}
            <mat-icon matTooltip="remove" (click)="remove(i)">clear</mat-icon>
        </div>
    </div>

    <div class="flex relative">
        <ig-field #field [label]="label" [isInnerLabel]="true" style="flex:8" [(ngModel)]="text"
                  [formControl]="form.get('text')"></ig-field>
        <ig-button size="md" style="flex:1;margin-top: 7px;height:35px;margin-left: 12px" (trigger)="add()">ADD
        </ig-button>

        <div #autocomplete *ngIf="filteredItems.length"
             class="ig-multi-fields-autocomplete">
            <div *ngFor="let item of filteredItems" class="text-left ig-multi-fields-autocomplete-item"
                 (click)="select(item)">{{ item }}
            </div>
        </div>
    </div>
</div>





// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/multiple.fields/multiple.fields.component.html